// SessionStates
export const SESSION_STATE = {
    INITIAL: { id: 0, label: '' },
    STARTING: { id: 1, label: 'starting' },
    CONNECTING: { id: 2, label: 'connecting' },
    RUNNING: { id: 3, label: 'playing' },
};
